exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rendezosav__btn[data-v-71800c4a]{letter-spacing:normal;font-weight:400}.rendezosav__btn__content[data-v-71800c4a]{margin-left:8px;display:flex;flex-direction:column;align-items:start}", ""]);

// exports
